import React from 'react';

const blue = '#0064E0';
const muted = '#8A8D91';

type IconProps = { className?: string; size?: number };

export function IconShield({ size = 48, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className} aria-hidden>
      <path
        d="M24 4L8 12v12c0 10.5 7.5 20.2 16 22 8.5-1.8 16-11.5 16-22V12L24 4z"
        stroke={blue}
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      <path
        d="M17 24l5 5 10-10"
        stroke={blue}
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function IconServerShield({ size = 48, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className} aria-hidden>
      <rect x="6" y="10" width="36" height="28" rx="3" stroke={muted} strokeWidth="2" />
      <path d="M6 18h36M6 26h36" stroke={muted} strokeWidth="2" />
      <circle cx="12" cy="14" r="1.5" fill={muted} />
      <path
        d="M28 30l3 3 6-6"
        stroke={muted}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function IconEye({ size = 32, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-hidden>
      <path
        d="M4 16c4-8 12-8 16 0s12 8 16 0-4-8-8-8-12 0-16 8-12 8-16 0z"
        stroke={blue}
        strokeWidth="2"
      />
      <circle cx="16" cy="16" r="4" stroke={blue} strokeWidth="2" />
    </svg>
  );
}

export function IconShieldCheck({ size = 32, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-hidden>
      <path
        d="M16 4L8 8v8c0 5.2 3.8 10 8 11.2 4.2-1.2 8-6 8-11.2V8l-8-4z"
        stroke={blue}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path d="M11 16l4 4 7-7" stroke={blue} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function IconBuilding({ size = 32, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-hidden>
      <path
        d="M6 28V10l10-5 10 5v18H6z"
        stroke={blue}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path d="M12 18v6M16 14v10M20 20v4" stroke={blue} strokeWidth="2" />
    </svg>
  );
}

export function IconSettings({ size = 32, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-hidden>
      <path
        d="M16 20a4 4 0 100-8 4 4 0 000 8z"
        stroke={blue}
        strokeWidth="2"
      />
      <path
        d="M16 4v2M16 26v2M6 16h2M24 16h2M8.34 8.34l1.42 1.42M22.24 22.24l1.42 1.42M8.34 23.66l1.42-1.42M22.24 9.76l1.42-1.42"
        stroke={blue}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function IconBrain({ size = 32, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-hidden>
      <path
        d="M10 18c-2 0-4-2-4-4s2-4 4-4M22 18c2 0 4-2 4-4s-2-4-4-4M10 18v2c0 2 2 4 4 4h4c2 0 4-2 4-4v-2M16 8v4M12 12c0-3 2.5-5 6-5s6 2 6 5"
        stroke={blue}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconGlobe({ size = 32, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-hidden>
      <circle cx="16" cy="16" r="12" stroke={blue} strokeWidth="2" />
      <path
        d="M4 16h24M16 4c3 4 3 20 0 24M16 4c-3 4-3 20 0 24"
        stroke={blue}
        strokeWidth="2"
      />
    </svg>
  );
}

export function IconDocument({ size = 32, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-hidden>
      <path
        d="M10 4h8l6 6v18a2 2 0 01-2 2H10a2 2 0 01-2-2V6a2 2 0 012-2z"
        stroke={blue}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path d="M18 4v6h6M10 14h8M10 18h12M10 22h8" stroke={blue} strokeWidth="2" />
    </svg>
  );
}

export function IconEnvelope({ size = 24, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <rect x="3" y="5" width="18" height="14" rx="2" stroke={blue} strokeWidth="2" />
      <path d="M3 7l9 6 9-6" stroke={blue} strokeWidth="2" strokeLinejoin="round" />
    </svg>
  );
}

export function IconHeadset({ size = 24, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <path
        d="M5 16v-2a7 7 0 0114 0v2M5 16v2a2 2 0 002 2h1M19 16v2a2 2 0 01-2 2h-1"
        stroke={blue}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path d="M9 18h.01M15 18h.01" stroke={blue} strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}

export function IconPeople({ size = 32, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-hidden>
      <circle cx="11" cy="11" r="4" stroke={blue} strokeWidth="2" />
      <path d="M4 26c0-4 3.5-6 7-6s7 2 7 6" stroke={blue} strokeWidth="2" />
      <circle cx="23" cy="12" r="3" stroke={blue} strokeWidth="2" />
      <path d="M28 26c0-3-2.5-4.5-5-4.5" stroke={blue} strokeWidth="2" />
    </svg>
  );
}

export function IconLightbulb({ size = 32, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-hidden>
      <path
        d="M16 4c-4.5 0-8 3.5-8 8 0 3 1.5 5.5 4 7v3h8v-3c2.5-1.5 4-4 4-7 0-4.5-3.5-8-8-8z"
        stroke={blue}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path d="M12 26h8M13 29h6" stroke={blue} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function IconKoklonya({ size = 48, className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className} aria-hidden>
      <path
        d="M24 43c-8 0-13-6.4-13-14 0-9.4 6-23 13-23s13 13.6 13 23c0 7.6-5 14-13 14z"
        stroke={blue}
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      <path
        d="M19 30c0 2.5 2.1 4.6 4.8 4.8"
        stroke={blue}
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function CheckIcon({ className }: { className?: string }) {
  return (
    <svg className={className} width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden>
      <path d="M4 9l4 4 7-7" stroke={blue} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
